import api from './api.js'

// token请求
const client = process.env.AUTH_CLIENT
export function token(params){
    return api.post('/service-auth/oauth/token', {}, {params: client});
}
// 账号密码登录
export function getUserAndPassLogin(params){
    return api.post('/service-auth/oauth/login',params);
}
// 获取当前用户登录信息
export function getNewcurrent(params){
    return api.get('/service-center/api/v1/user/current',params);
}
// 文件上传
export function uploadFile(params){
    return api.post('/service-center/upload/file/single',params);
}
// 成品展示列表接口
export function getPresentationList(params){
    return api.get('/resource-print/api/v1/presentation/query',params);
}
// 成品展示添加接口
export function addPresentationList(params){
    return api.post('/resource-print/api/v1/presentation',params);
}
// 成品展示删除接口
export function delPresentationList(params){
    return api.get('/resource-print/api/v1/presentation/deletePresentationList',params);
}
// 成品展示查询详情
export function getPresentationDetail(params){
    return api.get('/resource-print/api/v1/presentation/findMaterialDetail',params);
}
// 成品展示修改
export function editPresentation(params){
    return api.post(`/resource-print/api/v1/presentation/${params.uuid}`,params);
}
// 成品发布
export function publishPresentation(params){
    return api.get(`/resource-print/api/v1/presentation/issuePresentationList`,params);
}

// 收货地址展示列表接口
export function  getAddressList(params) {
    return api.get('/service-center/api/v1/address/query',params);
}

// 保存收货地址
export function saveAddressInfo(params) {
    return api.post('/service-center/api/v1/address',params);
}

// 收货地址查询详情
export function getAddressDetail(params){
    return api.get(`/service-center/api/v1/address/${params.uuid}`);
}

// 修改收货地址信息
export function editAddressInfo(params){
    return api.post(`/service-center/api/v1/address/${params.uuid}`,params);
}

// 设置为默认地址
export function setDefaultAddress(params){
    return api.post('/service-center/api/v1/address/setDefault?uuid='+params.uuid,params);
}

// 删除地址
export function delAddressInfo(params){
    return api.deleteUrl(`/service-center/api/v1/address/${params.uuid}`);
}

// 批量删除
export function delAllAddressInfo(params){
    return api.get('/service-center/api/v1/address/deleteList',params);
}

// 发票抬头列表展示
export function invoiceTitleList(params){
    return api.get('/service-center/api/v1/invoice/title/user',params);
}

// 新增发票抬头信息
export function saveInvoiceInfo(params){
    return api.post('/service-center/api/v1/invoice/title',params);
}

// 修改发票抬头信息
export function editInvoiceInfo(params){
    return api.put(`/service-center/api/v1/invoice/title/${params.uuid}`,params);
}

// 查询发票抬头详情
export function findInvoiceInfo(params){
    return api.get(`/service-center/api/v1/invoice/title/${params.uuid}`);
}

// 删除发票信息
export function deleteInvoiceInfo(params){
    return api.deleteUrl(`/service-center/api/v1/invoice/title/${params.uuid}`);
}

// 分页获取需求列表
export function demandListByPage(params){
    return api.get('/resource-design/api/v1/demand/queryByUser',params);
}

// 新增需求
export function addDemand(params){
    return api.post('/resource-design/api/v1/demand',params);
}

// 编辑需求
export function updateDemand(params){
    return api.post('/resource-design/api/v1/demand/update',params);
}
// 发布需求
export function publishDemand(params){
    return api.post('/resource-design/api/v1/demand/publish',params);
}

// 获取字典列表
export function getDictionaryItem(params){
    return api.get('/service-center/api/v1/dictionary/item',params);
}


// 获取字典列表
export function getDictionaryItemDetail(uuid){
    return api.get(`/service-center/api/v1/dictionary/item/${uuid}`);
}

// 模型订单查询接口
export function getModelOrderList(params){
    return api.get('/resource-order/api/v1/order/model/query',params);
}
// 模型详情接口
export function getModelDetail(params){
    return api.get(`/resource-design/api/v1/design/model/${params.uuid}`);
}
// 模型订单查询接口
export function getServiceOrderList(params){
    return api.get('/resource-order/api/v1/order/service/query',params);
}
export function getDictionaryGroup(params){
    return api.get('/service-center/api/v1/dictionary/group/list',params);
}
// 根据数据字典id查询材料类型信息
export function findTypeListByGroupUuid(params){
    return api.get('/resource-order/api/v1/material/type/findTypeListByGroupUuid',params);
}

// 买家查询订单详情
export function getPrintOrderList(params){
    return api.get('/resource-order/api/v1/order/print/proTable',params);
}


// 买家查询订单详情信息
export function getPrintOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/print/${params.uuid}`);
}

// 买家查询材料详情信息
export function findBuyerPrintOrderDetail(params){
    return api.get('/resource-print/api/v1/buyer/print/order/findBuyerPrintOrderDetail',params);
}

// 服务能力查询详情
export function getServiceDetail(params){
    return api.get('/resource-print/api/v1/serviceability/findMaterialDetail',params);
}

// 服务订单查询详情
export function getServiceOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/service/${params.uuid}`);
}

// 分页获取设计师-需求-模型关注-收藏列表
export function getCollectList(params){
    return api.get(`/resource-design/api/v1/designer/like/query`,params);
}
// 分页获取设计师-需求-模型关注-收藏列表Map
export function getCollectListByMap(params){
    return api.get(`/resource-design/api/v1/designer/like/queryMap`,params);
}
// 取消收藏设计师-需求-模型
export function deleteCollects(params){
    return api.post(`/resource-design/api/v1/designer/like/delete`,params);
}


// 获取模型订单详情
export function getModelOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/model/${params.uuid}`);
}

// 修改订单信息
export function updateOrderBaseInfo(params) {
    return api.post('/resource-order/api/v1/order/base/updateOrderBaseInfo',params);
}

// 卖家查询材料详情信息
export function updateBuyerPrintOrder(params){
    return api.post('/resource-print/api/v1/buyer/print/order/updateBuyerOrderInfo',params);
}

//
export function updateOrderServiceInfo(params){
    return api.post('/resource-order/api/v1/order/service/updateOrderServiceInfo',params);
}
//保存评论/追评
export function saveEvaluation(params){
    return api.post('/resource-order/api/v1/order/evaluation/save',params);
}

// 保存发票信息
export function savePrintReceipt(params){
    return api.post('/resource-print/api/v1/buyer/print/order/savePrintReceipt',params);
}

// 买家查询发票详情
export function getPrintReceiptOrderList(params){
    return api.get('/resource-order/api/v1/order/print/receipt/proTable',params);
}

export function getPrintReceiptInfo(params){
    return api.get('/resource-print/api/v1/buyer/print/order/getPrintReceiptInfo',params);
}

// 分页获取打印收藏列表
export function getPrintCollectList(params){
    return api.get('/resource-print/api/v1/collection/info/query',params);
}

// 取消收藏
export function removeCollection(params){
    return api.get('/resource-print/api/v1/collection/info/removeCollection',params);
}
//清空收藏
export function clearCollection(params){
    return api.get('/resource-print/api/v1/collection/info/clearCollection',params);
}

// 分页获取打印收藏列表
export function getPrintFollowList(params){
    return api.get('/resource-print/api/v1/follow/info/query',params);
}

// 取消关注
export function removeFollow(params){
    return api.get('/resource-print/api/v1/follow/info/removeFollow',params);
}

// 分页获取评价列表
export function getEvaluationList(params){
    return api.get(`/resource-order/api/v1/order/evaluation/query`,params);
}

//获取我的投诉列表
export function getOrderComplainList(params){
    return api.get('/resource-order/api/v1/order/complain/query',params);
}

//提交投诉
export function saveComplain(params){
    return api.post('/resource-order/api/v1/order/complain/save',params);
}

//取消投诉
export function cancelComplain(uuid){
    return api.post(`/resource-order/api/v1/order/complain/cancel/`+uuid);
}


// 保存服务发票信息
export function saveServiceReceipt(params){
    return api.post('/resource-order/api/v1/order/service/saveServiceReceipt',params);
}

//提交售后申请
export function saveAfterSale(params){
    return api.post('/resource-order/api/v1/order/afterSale/save',params);
}

//获取我的售后申请列表
export function getAfterSaleList(params){
    return api.get('/resource-order/api/v1/order/afterSale/query',params);
}

//获取我的退款明细列表
export function getReturnList(params){
    return api.get('/resource-order/api/v1/order/afterSale/returnList',params);
}

//重新提交售后申请
export function reApplyAfterSale(params){
    return api.post('/resource-order/api/v1/order/afterSale/reApply',params);
}

//买家售后发货
export function afterSaleSendOut(params){
    return api.post('/resource-order/api/v1/order/afterSale/sendOut',params);
}

// 查询参与报价的设计师
export function findDemandOfferList(params){
    return api.get('/resource-design/api/v1/demand/findDemandOffer',params);
}

// 选择设计师,然后生成订单
export function saveDemandOffer(params){
    return api.get('/resource-design/api/v1/demand/saveDemandOffer',params);
}

// 取消需求
export function cancelDemand(params){
    return api.get('/resource-design/api/v1/demand/cancelDemand',params);
}

// 设计订单保存
export function saveDesignOrder(params){
    return api.post('/resource-order/api/v1/order/design/save',params);
}

// 设计订单列表
export function getDesignOrderList(params){
    return api.get('/resource-order/api/v1/order/design/proTable',params);
}

// 修改状态
export function updateDesignOrderStatus(params){
    return api.get('/resource-order/api/v1/order/design/updateDesignOrderStatus',params);
}

// 获取订单详情
export function getDesignOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/design/${params.uuid}`);
}

// 需求详情
export function getDesignInfoDetail(params){
    return api.get(`/resource-design/api/v1/demand/portal/${params.uuid}`);
}

// 获取融云token
export function getRongCloudToken(params){
    return api.get('/service-center/api/v1/rongcloud/getToken',params);
}

//（融云用）根据目标id获取用户或者企业管理员
export function getRongCloudUser(uuid){
    return api.get('/service-center/api/v1/user/rongCloud/' + uuid);
}

// 查询文件列表
export function getDesignerDemandFile(params){
    return api.get('/resource-design/api/v1/designer/demand/getDesignerDemandFile',params);
}

// 查询文件列表
export function findUpdateRemark(params){
    return api.get('/resource-design/api/v1/designer/demand/findUpdateRemark',params);
}

// 添加修改意见
export function addUpdateRemark(params){
    return api.get('/resource-design/api/v1/designer/demand/addUpdateRemark',params);
}

// 添加确认时间
export function addConfirmTime(params){
    return api.get('/resource-design/api/v1/designer/demand/addConfirmTime',params);
}

// 设置为默认地址
export function cancelDefaultInvoice(params){
    return api.post(`/service-center/api/v1/invoice/title/cancel/${params.uuid}`);
}

// 查询参与报价的设计师
export function findChooseDemandOffer(params){
    return api.get('/resource-design/api/v1/demand/findChooseDemandOffer',params);
}

// 设置为默认地址
export function setDefaultInvoice(params){
    return api.post(`/service-center/api/v1/invoice/title/default/${params.uuid}`);
}

// 查询参与报价的设计师
export function deleteDemandInfo(params){
    return api.get('/resource-design/api/v1/demand/deleteDemand',params);
}

// 获取所有订单数据
// 获取打印订单
export function findAllPrintList(params){
    return api.get('/resource-order/api/v1/order/print/list',params);
}

// 获取服务订单
export function findAllServiceList(params){
    return api.get('/resource-order/api/v1/order/service/list',params);
}

// 获取设计订单
export function findAllDesignList(params){
    return api.get('/resource-order/api/v1/order/design/list',params);
}

// 获取订单数量
export function getPrintAndShopOrderNumber(){
    return api.get('/resource-order/api/v1/order/print/getPrintAndShopOrderNumber');
}

// 获取打印收藏列表
export function getAllPrintFollow(params){
    return api.get('/resource-print/api/v1/follow/info/list',params);
}

// 分页获取收藏资讯列表
export function getNewsCollectList(params){
    return api.get(`/resource-portal/api/v1/news/collection/query`,params);
}

// 取消收藏资讯
export function deleteNewsCollects(params){
    return api.post(`/resource-portal/api/v1/news/collection/delete`,params);
}
// 分页获取收藏软件列表
export function getSoftwareCollectList(params){
    return api.get(`/resource-portal/api/v1/software/manage/softwareCollectionQuery`,params);
}

// 取消收藏软件
export function deleteSoftwareCollects(params){
    return api.post(`/resource-portal/api/v1/software/manage/softwareCollectionDelete`,params);
}

// 分页获取软件订单列表
export function querySoftwareOrderDetailList(params){
    return api.get('/resource-order/api/v1/software/orderDetail/manage/query',params);
}

// 获取软件订单详情
export function getSoftwareOrderDetailByUuid(uuid){
    return api.get('/resource-order/api/v1/software/orderDetail/manage/' + uuid);
}

//修改订单
export function updateSoftwareOrder(params){
    return api.post('/resource-order/api/v1/software/orderDetail/manage/' + params.uuid, params);
}

// 发货
export function updateDeliverGoodsOrder(params) {
    return api.post('/resource-order/api/v1/deliverGoods/updateOrderBaseInfo',params);
}

// 实时物流查询
export function getLogisticsTrack(params) {
    return api.get('/resource-order/api/v1/logistics/kuaidi100/queryTrack',params);
}

// 上传作品
export function addActivityWorks(params){
    return api.post(`/resource-activity/api/v1/activity/works/${params.activityUuid}/${params.activityWayUuid}`,params);
}

// 查询作品审核列表
export function getWorksList(params){
    return api.get('/resource-activity/api/v1/activity/works/query',params);
}

// 查询作品详情信息
export function getWorksDetail(uuid){
    return api.get(`/resource-activity/api/v1/activity/works/${uuid}`);
}

// 查询活动类别
export function getActivityTypeList(params){
    return api.get("/resource-activity/api/v1/activity/manage/getActivityTypeList",params);
}

// 查询报名信息
export function getSignWorksList(params){
    return api.get("/resource-activity/api/v1/activity/sign/current",params);
}

// 查询详情
export function getViewUploadWorks(worksUuid){
    return api.get(`/resource-activity/api/v1/activity/works/view/${worksUuid}`);
}

// 更新列表
export function updateUploadWorks(params){
    return api.put(`/resource-activity/api/v1/activity/works/${params.uuid}`,params);
}


export function findServiceabilityTradeList(params){
    return api.get('/resource-print/api/v1/serviceability/findServiceabilityTradeList',params);
}


// 修改商城订单信息
export function updateOrderShopBaseInfo(params) {
    return api.post(`/resource-order/api/v1/order/base/updateOrderShopBaseInfo/${params.orderStatus}/${params.uuid}`,params);
}

// 修改商城订单信息
export function getOrderShopInfo(params) {
    return api.get('/resource-order/api/v1/order/shop/getOrderShopInfo',params);
}

// 商城列表
export function getOrderShopList(params){
    return api.get('/resource-order/api/v1/order/shop/query',params);
}

// 商城列表
export function getAllShopList(){
    return api.get('/resource-order/api/v1/order/shop/getAllShopList');
}

// 测试
// 短信登录
export function getMessagesLogin(params){
    return api.post('/service-auth/sms/login',params);
}
// 获取安全校验码
export function getSecurityCode(params){
    return api.get('/service-auth/api/v2/validate/code',params);
}
// 点击获取短息
export function getSmscode(params){
    return api.get('/service-auth/api/v2/sms/code',params);
}
// 校验用户名是否存在
export function existsUserName(params){
    return api.get('/service-center/api/v1/security/account/exists',params);
}
// 忘记密码
export function editPassword(params){
    return api.put('/service-center/api/v2/security/account/password',params);
}
// 注册接口
export function getRegistered(params){
    return api.post('/service-auth/api/v2/register',params);
}

// 模型订单新增、取消接口
export function editOrder(params){
    return api.post('/resource-order/api/v1/order/model/save',params);
}

// 打包下载模型文件
export function downloadFile(uuid){
    return api.getFile('/resource-order/api/v1/order/model/downloadFile/'+uuid);
}

// 线下支付订单保存支付凭证
export function offlinePay(params){
    return api.post('/resource-order/api/v1/order/base/offlinePay',params);
}
// 先行支付订单保存
export function platformAdvances(params){
    return api.post('/resource-order/api/v1/order/base/platformAdvances',params);
}

//查询订单是否支持线上付款
export function onLineCheck(orderNo){
    return api.get(`/resource-pay/api/v1/yop/order/onLineCheck/${orderNo}`);
}

// 货到付款订单保存支付凭证
export function deliveryOnCash(params){
    return api.post('/resource-order/api/v1/order/base/deliveryOnCash',params);
}

// 获取签章列表
export function getSignatureList(params){
    return api.get('/resource-order/api/v1/contract/signature/query',params);
}
// 保存签章信息
export function saveSignature(params){
    return api.post('/resource-order/api/v1/contract/signature',params);
}
// 更新签章信息
export function updateSignature(params,uuid){
    return api.put('/resource-order/api/v1/contract/signature/'+uuid,params);
}
// 删除签章信息
export function deleteSignature(uuid){
    return api.deleteUrl(`/resource-order/api/v1/contract/signature/${uuid}`);
}
// 获取签章信息
export function getSignatureInfo(uuid){
    return api.get(`/resource-order/api/v1/contract/signature/detail?uuid=${uuid}`,);
}

// 获取合同模板列表
export function getContractTemplateList(params){
    return api.get('/resource-order/api/v1/contract/template/query',params);
}
// 保存合同模板信息
export function saveContractTemplate(params){
    return api.post('/resource-order/api/v1/contract/template',params);
}
// 更新合同模板信息
export function updateContractTemplate(params,uuid){
    return api.put('/resource-order/api/v1/contract/template/'+uuid,params);
}
// 删除合同模板信息
export function deleteContractTemplate(uuid){
    return api.deleteUrl(`/resource-order/api/v1/contract/template/${uuid}`);
}
// 获取合同模板信息
export function getContractTemplateInfo(uuid){
    return api.get(`/resource-order/api/v1/contract/template/detail?uuid=${uuid}`,);
}
//获取合同模板订单类型
export function getContractOrderTypes(){
    return api.get('/resource-order/api/v1/contract/template/orderTypes');
}


// 获取合同列表
export function getContractList(params){
    return api.get('/resource-order/api/v1/contract/query',params);
}
// 保存合同信息
export function saveContract(params){
    return api.post('/resource-order/api/v1/contract',params);
}
// 更新合同信息
export function updateContract(params,uuid){
    return api.put('/resource-order/api/v1/contract/'+uuid,params);
}
// 删除合同信息
export function deleteContract(uuid){
    return api.deleteUrl(`/resource-order/api/v1/contract/${uuid}`);
}
// 修改合同状态
export function updateContractStatus(uuid, status){
    return api.get('/resource-order/api/v1/contract/updateStatus?uuid=' + uuid + "&status=" + status);
}

export function signContract(uuid,signatureUuid){
    return api.post('/resource-order/api/v1/contract/sign?uuid='+uuid+"&signatureUuid="+signatureUuid);
}
// 获取合同信息
export function getContractInfo(uuid){
    return api.get(`/resource-order/api/v1/contract/detail?uuid=${uuid}`,);
}

//获取买家合同订单列表
export function getContractBuyerOrderByOrderNo(orderNo){
    return api.get('/resource-order/api/v1/contract/buyerOrder?orderNo=' + orderNo);
}

//审核合同
export function auditContract(params){
    return api.get('/resource-order/api/v1/contract/auditContract',params);
}

// 生成二维码接口
export function generateQrCode(parmas){
    return api.get('/service-auth/api/v1/qr/code',parmas);
}
// 获取扫码结果接口
export function scanCodeInfo(parmas){
    return api.get('/service-auth/api/v1/qr/code/info',parmas);
}
// 微信授权登录
export function weChatLogin(parmas){
    return api.get('/service-auth/api/v1/social/wechat',parmas);
}
// 微信登录账号绑定接口
export function weChatBind(parmas){
    return api.post('/service-auth/api/v1/social/wechat/bind',parmas);
}
//查询资质详情
export function getWorksQualification(uuid){
    return api.get(`/resource-activity/api/v1/activity/works/qualification/${uuid}`);
}
//提交资质信息
export function addWorksQualification(params){
    return api.post('/resource-activity/api/v1/activity/works/qualification',params);
}



// WEBPACK FOOTER //
// ./src/utils/interface.js